import {AsyncAction} from 'overmind'
import {ImportSitesRequest, ImportSitesResult} from './state'

export const importSites: AsyncAction<any, ImportSitesResult> = async (
  {state, effects},
  request: ImportSitesRequest
) => {
  const response = await effects.v1.settings.sites.siteImportApi.importSites(request)
  return response
}
